import MarkdownIt from 'markdown-it';
import mila from 'markdown-it-link-attributes';
import hljs from 'highlight.js/lib/common';
import 'highlight.js/styles/atom-one-dark.min.css';
import mermaid from 'mermaid';
import MermaidPlugin from '@/utils/md/MarkdownItMermaidPlugin.js';

function highlightBlock(str, lang) {
  return `<pre class="theme-atom-one-dark not-prose"><code class="rounded hljs language-${lang}">${str}</code></pre>`;
}

export const useMd = () => {
  const mdIt = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
    highlight(code, language) {
      const validLang = !!(language && hljs.getLanguage(language));
      if (validLang) {
        const lang = language ?? '';
        return highlightBlock(hljs.highlight(code, { language: lang }).value, lang);
      }
      return highlightBlock(hljs.highlightAuto(code).value, '');
    },
  });

  mdIt.use(mila, { attrs: { target: '_blank', rel: 'noopener' } });

  mermaid.initialize({
    securityLevel: 'loose',
    startOnLoad: false,
    theme: 'base',
    themeVariables: {
      darkMode: true,
      pie1: '#4269d0', // blue
      pie2: '#efb118', // orange
      pie3: '#ff725c', // red
      pie4: '#6cc5b0', // cyan
      pie5: '#3ca951', // green
      pie6: '#ff8ab7', // pink
      pie7: '#a463f2', // purple
      pie8: '#97bbf5', // light blue
      pie9: '#9c6b4e', // brown
      pie10: '#9498a0', // gray
      xyChart: {
        backgroundColor: '#1e293b',
        titleColor: '#e2e8f0',
        xAxisLabelColor: '#e2e8f0',
        xAxisTitleColor: '#e2e8f0',
        xAxisTickColor: '#94a3b8',
        xAxisLineColor: '#94a3b8',
        yAxisLabelColor: '#e2e8f0',
        yAxisTitleColor: '#e2e8f0',
        yAxisTickColor: '#94a3b8',
        yAxisLineColor: '#94a3b8',
        plotColorPalette: '#4269d0,#efb118,#ff725c,#6cc5b0,#3ca951,#ff8ab7,#a463f2,#97bbf5,#9c6b4e,#9498a0',
      },
    },
  });
  mdIt.use(MermaidPlugin);

  const mdToHtml = (md) => {
    const html = mdIt.render(md);
    return html;
  };

  return {
    mdToHtml,
  };
};
